import {createAction, props} from '@ngrx/store';
import {
  ApiDeviceGroupActionResponseDto,
  ApiDeviceGroupListResponseDto,
  ApiDeviceGroupRequestDto,
  ApiDeviceGroupResponseDto,
} from '@birco/rainmesh-api';
import {DeviceGroupFilter} from './device-group.state';

const ACTION_PREFIX = '[DeviceGroup]';

export const DeviceGroupActions = {
  public: {
    updateDeviceGroupFilter: createAction(
      `${ACTION_PREFIX} updateDeviceGroupFilter`,
      props<{ filter: DeviceGroupFilter }>(),
    ),

    loadAllDeviceGroupsByFilters: createAction(
      `${ACTION_PREFIX} loadAllDeviceGroupsByFilters`,
      props<{ filter?: DeviceGroupFilter }>(),
    ),

    triggerDeviceGroupAction: createAction(
      `${ACTION_PREFIX} triggerDeviceGroupAction`,
      props<{ id: string; value: boolean }>(),
    ),

    loadDeviceGroupById: createAction(
      `${ACTION_PREFIX} loadDeviceGroupById`,
      props<{ id: string }>(),
    ),

    createDeviceGroup: createAction(
      `${ACTION_PREFIX} createDeviceGroup`,
      props<{ requestDto: ApiDeviceGroupRequestDto }>(),
    ),

    updateDeviceGroup: createAction(
      `${ACTION_PREFIX} updateDeviceGroup`,
      props<{ id: string; requestDto: ApiDeviceGroupRequestDto }>(),
    ),

    deleteDeviceGroupById: createAction(
      `${ACTION_PREFIX} deleteDeviceGroupById`,
      props<{ id: string }>(),
    ),

    setDeviceGroupExpanded: createAction(
      `${ACTION_PREFIX} setDeviceGroupExpanded`,
      props<{ id: string; isExpanded: boolean }>(),
    ),
  },

  private: {
    loadDeviceGroupsWithFilters: createAction(`${ACTION_PREFIX} loadDeviceGroupsWithFilters`),

    loadDeviceGroupsSuccess: createAction(
      `${ACTION_PREFIX} loadDeviceGroupsSuccess`,
      props<{ deviceGroupsResponseDto: ApiDeviceGroupListResponseDto }>(),
    ),

    loadDeviceGroupsFailure: createAction(
      `${ACTION_PREFIX} loadDeviceGroupsFailure`,
      props<{ error: any }>(),
    ),

    loadDeviceGroupsWithProvidedFilters: createAction(
      `${ACTION_PREFIX} loadDeviceGroupsWithProvidedFilters`,
      props<{ filter: DeviceGroupFilter }>(),
    ),

    loadDeviceGroupsWithProvidedFiltersSuccess: createAction(
      `${ACTION_PREFIX} loadDeviceGroupsWithProvidedFiltersSuccess`,
      props<{ deviceGroupsResponseDto: ApiDeviceGroupListResponseDto }>(),
    ),

    loadDeviceGroupsWithProvidedFiltersFailure: createAction(
      `${ACTION_PREFIX} loadDeviceGroupsWithProvidedFiltersFailure`,
      props<{ error: any }>(),
    ),

    loadAllDeviceGroupsByFiltersSuccess: createAction(`${ACTION_PREFIX} loadAllDeviceGroupsByFiltersSuccess`),

    loadAllDeviceGroupsByFiltersFailure: createAction(
      `${ACTION_PREFIX} loadAllDeviceGroupsByFiltersFailure`,
      props<{ error: any }>(),
    ),

    loadNextOfAll: createAction(
      `${ACTION_PREFIX} loadNextOfAll`,
      props<{ page: number; filter: DeviceGroupFilter }>(),
    ),

    loadNextOfAllSuccess: createAction(
      `${ACTION_PREFIX} loadNextOfAllSuccess`,
      props<{ deviceGroupsResponseDto: ApiDeviceGroupListResponseDto }>(),
    ),

    loadNextOfAllFailure: createAction(
      `${ACTION_PREFIX} loadNextOfAllFailure`,
      props<{ error: any }>(),
    ),

    triggerDeviceGroupActionSuccess: createAction(
      `${ACTION_PREFIX} triggerDeviceGroupActionSuccess`,
      props<{ responseDto: ApiDeviceGroupActionResponseDto }>(),
    ),

    triggerDeviceGroupActionFailure: createAction(
      `${ACTION_PREFIX} triggerDeviceGroupActionFailure`,
      props<{ id: string; error: any }>(),
    ),

    loadDeviceGroupByIdSuccess: createAction(
      `${ACTION_PREFIX} loadDeviceGroupByIdSuccess`,
      props<{ responseDto: ApiDeviceGroupResponseDto }>(),
    ),

    loadDeviceGroupByIdFailure: createAction(
      `${ACTION_PREFIX} loadDeviceGroupByIdFailure`,
      props<{ id: string; error: any }>(),
    ),

    createDeviceGroupSuccess: createAction(
      `${ACTION_PREFIX} createDeviceGroupSuccess`,
      props<{ responseDto: ApiDeviceGroupResponseDto }>(),
    ),

    createDeviceGroupFailure: createAction(
      `${ACTION_PREFIX} createDeviceGroupFailure`,
      props<{ error: any }>(),
    ),

    updateDeviceGroupSuccess: createAction(
      `${ACTION_PREFIX} updateDeviceGroupSuccess`,
      props<{ responseDto: ApiDeviceGroupResponseDto }>(),
    ),

    updateDeviceGroupFailure: createAction(
      `${ACTION_PREFIX} updateDeviceGroupFailure`,
      props<{ id: string; error: any }>(),
    ),

    deleteDeviceGroupSuccess: createAction(
      `${ACTION_PREFIX} deleteDeviceGroupSuccess`,
      props<{ id: string }>(),
    ),

    deleteDeviceGroupFailure: createAction(
      `${ACTION_PREFIX} deleteDeviceGroupFailure`,
      props<{ id: string; error: any }>(),
    ),
  },
};
